import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {buildGroupsAccessibleByUser} from '../../../helpers/models/cardGroupHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {AppState} from '../../../store/appState';
import {getCardGroups} from '../../../store/data/dataSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {getUserTeams} from '../../../store/data/teams/teamsSelectors';
import {ContactHeaderGroups} from './contactHeaderGroups';

/*
 * Props.
 */

interface ContactHeaderGroupsContainerProps {
  card: CardModel;
}

/*
 * Selectors.
 */

function getCardGroupIds(_state: AppState, props: ContactHeaderGroupsContainerProps) {
  return props.card?.groupIds ?? [];
}

function makeGetCardGroups() {
  return createSelector(
    [getCardGroups, getCardGroupIds, getUserTeams, getUserNamespace],
    (groups, cardGroupIds, userTeams, userNamespace) =>
      buildGroupsAccessibleByUser(groups, cardGroupIds, userTeams, userNamespace),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactHeaderGroupsContainerProps>()(() => {
  const getGroups = makeGetCardGroups();
  return {
    groups: getGroups,
  };
});

export const ContactHeaderGroupsContainer = connect(mapStateToProps)(ContactHeaderGroups);
